import { ErrorOutline as ErrorOutlineIcon, HighlightOff as HighlightOffIcon } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { getBorderColor } from '../common';

interface Props {
  id?: string;
  helperText?: string;
  error?: boolean;
  warning?: boolean;
  info?: boolean;
  helperTextSx?: SxProps<Theme>;
}

const ROHelperText = ({ id, error, warning, info, helperText, helperTextSx }: Props): JSX.Element => {
  const borderColor = getBorderColor(error, warning, info);
  const Icon = error ? HighlightOffIcon : warning || info ? ErrorOutlineIcon : null;

  // Color should follow border color, unless there no error state in which case we want a darler
  // text color
  const displayText = () => {
    if (error && !helperText) return 'This field is required';
    if (helperText) return helperText;
    return null;
  };

  return displayText() ? (
    <Stack
      component={'span'}
      direction="row"
      gap={0.5}
      color={borderColor}
      alignItems="center"
      className={error ? 'error-text' : ''}>
      {Icon && <Icon sx={{ width: '16px', height: '16px' }} />}
      <Typography variant="caption" color={borderColor} sx={helperTextSx} data-testid={`helper-text-${id}`}>
        {displayText()}
      </Typography>
    </Stack>
  ) : (
    <></>
  );
};

export default ROHelperText;
